export default "__VITE_ASSET__VbtgbSP9__"